import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 2 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0.5 3.5H1V7H1.5",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0.875 2C1.28921 2 1.625 1.66421 1.625 1.25C1.625 0.835786 1.28921 0.5 0.875 0.5C0.460786 0.5 0.125 0.835786 0.125 1.25C0.125 1.66421 0.460786 2 0.875 2Z",
		fill: "currentColor"
	})]
});
export default SvgInfo;
